import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapDrawerLocation from '../enums/MapDrawerLocation';
import MapLocation from '../enums/MapLocation';
import MapOverlay from '../enums/MapOverlay';
import MenuEntryType from '../enums/MenuEntryType';

type logMapOverlayTappedParams = {
  entry_menu?: MenuEntryType;
  is_addition: boolean;
  is_authorized?: boolean;
  map_drawer_location?: MapDrawerLocation;
  map_location: MapLocation;
  map_overlay: MapOverlay;
};

/**
 * A user toggles an overlay from the base layer drawer on a map view to add/remove an overlay.
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_menu - The menu button that was clicked to open the basemap and layer menus.
 * @param params.is_addition - A boolean denoting if the overlay was added as a result of the action. If false, the overlay was removed.
 * @param params.is_authorized - Whether the user was entitled to the layer at the time of the tap. When false the layer was not applied and an upsell was presented instead, so the tap should not be counted as a removal.
 * @param params.map_drawer_location - The drawer tab that the map layer was in.
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.map_overlay - A string representing the map overlay selected.
 */
const logMapOverlayTapped = (
  { entry_menu, is_addition, is_authorized, map_drawer_location, map_location, map_overlay }: logMapOverlayTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'map overlay tapped',
    {
      'entry menu': entry_menu,
      'is addition': is_addition,
      'is authorized': is_authorized,
      'map drawer location': map_drawer_location,
      'map location': map_location,
      'map overlay': map_overlay
    },
    callback
  );
};

export default logMapOverlayTapped;
